import { OpenInNew } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { getOwnerNotification } from "actions/ownerNotification";
import { Modal, Severity } from "components";
import { Field } from "components/DataTable/renderComponents";
import { Loader } from "empower-energy-owner-components";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { formatDate } from "utils/dayjs";

const styles = () => {
  return {
    px: 1,
    "& .render-field": {
      mb: 0.5,
    },
  };
};

const OwnerNotificationModal = ({ open, onClose, siteId, id }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const details = useSelector((state) => state.ownerNotification?.details);
  const loading = useSelector((state) => state.ownerNotification?.loading);

  useEffect(() => {
    if (id) {
      dispatch(getOwnerNotification(siteId, id));
    }
  }, [dispatch, siteId, id]);

  const getDate = (d) =>
    d ? formatDate(d * 1000, "hh:mma DD MMM YYYY") : "NA";

  const onClickLink = (link) => {
    if (link.external) {
      window.open(link?.url, "_blank");
    } else {
      navigate(link?.url);
    }
  };

  return (
    <Modal open={open} onClose={onClose} width={800} top={"10%"}>
      {loading && <Loader show={true} />}
      {!loading && (
        <Box sx={styles}>
          <Box mb={1}>
            <Typography variant="h4" mb={1}>
              Notification - {details?.title}
            </Typography>
            <Field
              label="Timestamp"
              value={getDate(details?.timestamp * 1000)}
            />
            <Field label="Resolved" value={getDate(details?.resolved * 1000)} />
            <Field
              label="Acknowledged"
              value={getDate(details?.acknowledge * 1000)}
            />
            <Field label="Deleted" value={getDate(details?.deleted * 1000)} />
          </Box>

          <Box mb={1}>
            <Typography variant="h4" mb={1}>
              Content
            </Typography>
            <Field label="Event" value={details?.event} />
            <Field
              label="Severity"
              value={
                <Severity
                  severity={details?.severity}
                  variant="body2"
                  fontWeight="500"
                />
              }
            />
            <Field label="Name" value={details?.name} />
            <Field label="Description" value={details?.description} />
            <Field label="Resolved Name" value={details?.resolved_name} />
            <Field
              label="Resolved Description"
              value={details?.resolved_description}
            />
          </Box>

          <Box mb={1}>
            <Typography variant="h4" mb={1}>
              Links
            </Typography>
            {details.links?.map((link, i) => (
              <Box
                key={i}
                className="flex items-center"
                mb={0.5}
                gap={1}
                onClick={() => onClickLink(link)}
              >
                <Typography
                  variant="body2"
                  sx={{ textDecoration: "underline" }}
                  fontWeight={500}
                >
                  {link.name}
                </Typography>
                <OpenInNew fontSize="small" />
              </Box>
            ))}
          </Box>

          <Box mb={1}>
            <Typography variant="h4" mb={1}>
              Channels
            </Typography>
            {details?.channels &&
              Object.entries(details?.channels).map(([key, value]) => {
                const now = new Date();
                const expiryDate = new Date(value.expiry * 1000);
                const labelName = key.charAt(0).toUpperCase() + key.slice(1);

                let label = "";

                if (expiryDate < now) {
                  label = `${labelName} notification expired on ${formatDate(
                    value.expiry * 1000,
                  )}`;
                } else {
                  label = `${labelName} notification is expiring on ${formatDate(
                    value.expiry * 1000,
                  )}`;
                }
                return (
                  <Typography key={key} variant="body2" fontWeight={500}>
                    {label}
                  </Typography>
                );
              })}
          </Box>
        </Box>
      )}
    </Modal>
  );
};

export default OwnerNotificationModal;
